import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as StoreProvider } from "react-redux";
import "./assets/css/paper-dashboard.min.css";
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import "./app.scss";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "sweetalert2/dist/sweetalert2.css";
import { store } from "./store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<StoreProvider store={store}>
    <App />
</StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
